import _ from "lodash";
import { HttpService } from "@/core";
import {
  GuaranteeAgreementPageReq,
  GuaranteeAgreementPageResp,
  ProfileSimpleListReq,
  GuaranteeAgreementDetailResp,
  GuaranteeAgreementReq,
} from "./guarantee-agreement.interface";

export class GuaranteeAgreementService {
  static usePageApi() {
    const api = (data: GuaranteeAgreementPageReq) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance/guaranteeAgreement/query",
        data,
      });
    return HttpService.usePagination<GuaranteeAgreementPageResp>(api);
  }

  static useSimpleListApi() {
    const api = (params={}, url = "/maintenance/guaranteeAgreement/queryAll") =>
      HttpService.axios({
        method: "POST",
        url,
        data:params,
      });
    return HttpService.usePagination<any>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/maintenance/guaranteeAgreement/queryById/${id}`,
      });
    return HttpService.useRequest<GuaranteeAgreementDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: GuaranteeAgreementReq) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance/guaranteeAgreement/add",
        data: data,
      });
    return HttpService.useRequest<GuaranteeAgreementDetailResp>(api);
  }

  static useEditApi() {
    const api = (id: string, data: GuaranteeAgreementReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/maintenance/guaranteeAgreement/update/${id}`,
        data,
      });
    return HttpService.useRequest<GuaranteeAgreementDetailResp>(api);
  }

  //获取工程合同与电子合同信息
  static useGetContractApi() {
    const api = (maintenanceProjectId: string) =>
      HttpService.axios({
        method: "GET",
        url: `/maintenance/guaranteeAgreement/queryContactByProjectId/${maintenanceProjectId}`,
      });
    return HttpService.useRequest<any>(api);
  }
}
